// odkaz na generovani hashe hesla:
// https://tools.keycdn.com/sha256-online-generator


const correctHashes = [
    `b7681e01bb094b4ccbe8ca1ccbac9128873cd572e157cb62ed25868f4c30347f`, // 2026/2027
    `5d16945111a7ed298605caf6f42d0e3ae3aca9a102a7d9faad32a7749008063c`, // 2026/2027
    '2e19d48c7f921bd47f0856c8f0a815e7bc7b8f20d56a94dbaa836a6e6e61889e', // 2025/2026
    'a268f9f4f6508439db3d94afb51714c396bd176398a09a4b7227105eee140d8b' // admin
]

export default correctHashes
